var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":parseInt(_vm.value),"disabled":_vm.disabled,"hide-details":"","flat":"","height":_vm.height || undefined},on:{"change":v => _vm.emitInput(0, v),"input":v => _vm.clearInput(v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }